import React, { useCallback, useMemo, useState } from 'react';
import cx from 'classnames';

import { NotificationManager, SiteConfigManager } from '@atlas/core';
import { BasePopup, Button, Icon, Label } from '@atlas/ui';

import StaticBlock from 'common/StaticBlock/StaticBlock';
import { useIsRtl } from 'hooks/useIsRtl';
import PropTypes from 'prop-types';

const AdultPopup = ({ data: { isForbidden, onError, onSuccess } = {}, id }) => {
  const [isForbiddenPopup, setForbiddenPopup] = useState(!!isForbidden);
  const staticBlock = SiteConfigManager.getConfig('config.config.general.popup18StaticBlock');
  const isRtl = useIsRtl();
  const classNames = useMemo(
    () => ({
      content: cx('messages-popup__content messages-popup__content-multi', {
        'messages-popup__content-multi-center': isForbiddenPopup,
        'messages-popup__content-multi-no-static': isForbiddenPopup || !staticBlock,
        'messages-popup__content-multi-padding': !isForbiddenPopup && staticBlock,
        'messages-popup__content-multi-rtl': isRtl,
      }),
    }),
    [staticBlock, isRtl, isForbiddenPopup],
  );

  const onSuccessHandler = useCallback(() => {
    NotificationManager.removeNotification(id);
    onSuccess();
  }, [id, onSuccess]);

  const onErrorHandler = useCallback(() => {
    setForbiddenPopup(true);
    onError();
  }, [onError]);

  return (
    <BasePopup className="messages-popup messages-multi">
      {isForbiddenPopup && (
        <div className={classNames.content}>
          <Icon height={48} name="verify" width={48} />
          <Label
            className="messages-popup__content-multi-title messages-popup__content-multi-label"
            message="adult_forbidden_title"
          />
          <Label
            className="messages-popup__content-multi-label"
            message="adult_forbidden_description"
          />
        </div>
      )}

      {!isForbiddenPopup && (
        <>
          <div className={classNames.content}>
            {!!staticBlock && (
              <StaticBlock
                options={{
                  source: staticBlock,
                }}
              />
            )}
          </div>

          <div className="messages-popup__control">
            <Button
              className="secondary big block"
              label="adult_no_button_name"
              onClick={onErrorHandler}
            />
            <Button
              className="primary big block"
              label="adult_yes_button_name"
              onClick={onSuccessHandler}
            />
          </div>
        </>
      )}
    </BasePopup>
  );
};

AdultPopup.propTypes = {
  data: PropTypes.object.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default AdultPopup;
